import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || "http://localhost:8000/api",
});

api.interceptors.request.use((config) => {
  const location = JSON.parse(localStorage.getItem("lab_booking_location") || "null");
  if (location?.latitude && location?.longitude) {
    config.headers.latitudeUserLocation = location.latitude;
    config.headers.longitudeUserLocation = location.longitude;
    if (location.pincode) {
      config.headers.postalCodeUserLocation = location.pincode;
    }
  }

  const token = localStorage.getItem("lab_booking_token");
  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Log all non-2xx API errors in dev so we can see the real backend message.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (process.env.NODE_ENV !== "production") {
      console.error(
        "[api]",
        err.config?.method?.toUpperCase(),
        err.config?.url,
        "→",
        err.response?.status,
        err.response?.data
      );
    }
    return Promise.reject(err);
  }
);

export default api;
